import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import Pagination from "../../../Utility/Pagination/Pagination";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteUserdashboardAction,
  getUserAndSubuserAction,
} from "../../../../redux/actions/ManageAdminAction";
import notify from "../../../Notifcation";
import { FormControl, MenuItem, Select } from "@mui/material";
const Display = ({
  setKey,
  setPhone,
  showDelete,
  setshowDelete,
  setEmail,
  setName,
  setfoc,
  setIsPress,
  setLoading,
  setItemid,
  Itemid,
  loading,
  isPress,
}) => {
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setItemid(itemid);
  };
  const [Namese, setNamese] = useState("");
  const [Datee2, setDate2] = useState("");
  const [Datee1, setDate1] = useState("");
  const [Date2add, setDate2adaa] = useState("");
  const [Phonese, setPhonese] = useState("");
  const [PageSize, setPageSize] = useState(30);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUserAndSubuserAction(`PageSize=${PageSize}`));
  }, [PageSize]);
  const userAndsubuser = useSelector(
    (state) => state.ManageAdminR.UserAndSubuser
  );

  const { DeleteUserdash } = useSelector((state) => state.ManageAdminR);
  const onPress = async (page) => {
    await dispatch(
      getUserAndSubuserAction(`PageNumber=${page}&PageSize=${PageSize}`)
    );
  };
  const handleChangelist = (e) => {
    setPageSize(e.target.value);
  };

  const updateitem = (item) => {
    setKey("enter");
    setfoc(true);
    setItemid(item.Id);
    setName(item.Name);
    setEmail(item.Email);
    setPhone(item.PhoneNumber);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setIsPress(true);
    await dispatch(
      getUserAndSubuserAction(
        `Name=${Namese}&PhoneNumber=${Phonese}&FromDate=${Datee1}&ToDate=${Date2add.split(
          "/"
        )
          .reverse()
          .join("/")}&PageSize=${PageSize}`
      )
    );
    setLoading(false);
    setIsPress(false);
  };

  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteUserdashboardAction(Itemid));
    await dispatch(getUserAndSubuserAction());
    setLoading(false);
    setshowDelete(false);
    setIsPress(false);
  };

  useEffect(() => {
    if (loading === false) {
      if (DeleteUserdash && DeleteUserdash.ResponseMessage) {
        if (DeleteUserdash.ResponseMessage === "User deleted successfully") {
          notify("تم الحذف  بنجاح", "success");
        }
        if (DeleteUserdash.ResponseMessage !== "User deleted successfully") {
          notify("حدثة مشكلة حاول مرة اخرى", "success");
        }
      }
    }
  }, [loading]);

  return (
    <>
      <Container>
        <div className="inputs-container">
          <div className="inp-container dateer ">
            <div className="dateee">
              {Datee1 ? Datee1.split("-").reverse().join("-") : null}
            </div>
            <i className="ty fa-solid fa-calendar-days"></i>
            <TextField
              label="التاريخ من"
              variant="outlined"
              type="date"
              value={Datee1}
              onChange={(e) => setDate1(e.target.value)}
            />
          </div>
          <div className="inp-container  dateer">
            <div className="dateee">
              {Datee2 ? Datee2.split("-").reverse().join("-") : null}
            </div>
            <i className="ty fa-solid fa-calendar-days"></i>
            <TextField
              label="التاريخ إلى"
              variant="outlined"
              type="date"
              value={Datee2}
              onChange={(e) => {
                setDate2(e.target.value);
                const dat2 = new Date(e.target.value);
                dat2.setDate(dat2.getDate() + 1);
                setDate2adaa(dat2.toLocaleDateString("en-GB"));
              }}
            />
          </div>
          <div className="inp-container">
            {" "}
            <TextField
              label={"اسم المستخدم"}
              variant="outlined"
              value={Namese}
              onChange={(e) => setNamese(e.target.value)}
              inputProps={{ maxLength: 120 }}
              type="text"
            />
          </div>
          <div className="inp-container ">
            {" "}
            <TextField
              label={"رقم الهاتف"}
              variant="outlined"
              value={Phonese}
              onChange={(e) => setPhonese(e.target.value)}
              inputProps={{ maxLength: 15 }}
              type="number"
            />
          </div>
          <div className="inp-container"></div>
          <div className="inp-container"></div>
        </div>
        {isPress && loading ? (
          <button className="buttonadd">
            <Spinner animation="border" role="status"></Spinner>
          </button>
        ) : (
          <button className="buttonadd" onClick={handleSubmit}>
            بحث
          </button>
        )}
        <hr />
        <Table responsive striped bordered hover>
          <thead>
            <tr>
              <th>
                م<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                تاريخ الأنشاء<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                اسم المستخدم <i className="fa-solid fa-calendar-days"></i>
              </th>
              <th>
                رقم الهاتف<i className="fa-solid fa-user-group"></i>
              </th>
              <th>
                الإيميل<i className="fa-solid fa-user-group"></i>
              </th>
              <th>
                نوع الحساب<i className="fa-solid fa-user-group"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {userAndsubuser &&
            userAndsubuser.data &&
            userAndsubuser.data.Data.length > 0
              ? userAndsubuser.data.Data.map((item, idx) => {
                  const date = new Date(item.CreatedDate);
                  const total =
                    (userAndsubuser.data.CurrentPage - 1) *
                    userAndsubuser.data.ItemsPerPage;
                  return (
                    <tr key={item.Id} onDoubleClick={() => updateitem(item)}>
                      <td>{parseInt(total + 1 + idx)}</td>
                      <td>{date.toLocaleDateString("en-GB")}</td>
                      <td>{item.Name}</td>
                      <td>{item.PhoneNumber}</td>
                      <td>{item.Email}</td>
                      <td>{item.RoleName}</td>
                      <td className="icon-w">
                        <i
                          onClick={() => updateitem(item)}
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "rgb(0 44 146)" }}></i>
                      </td>
                      <td className="icon-w">
                        {" "}
                        <i
                          onClick={() => handleShoweDelete(item.Id)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "red" }}></i>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>

        <hr />
        <div className="pag">
          <FormControl style={{ width: "80px", height: "41px" }}>
            <Select
              value={PageSize}
              // className="tyt"

              onChange={handleChangelist}>
              <MenuItem value={30}>30</MenuItem>
              <MenuItem value={60}>60</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
          <Pagination
            onPress={onPress}
            PageCount={
              userAndsubuser && userAndsubuser.data
                ? userAndsubuser.data.TotalPages
                : null
            }
          />
        </div>
      </Container>
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
export default Display;
